import Empty from '@/views/Empty';
import AdminIndex from '@/views/pages/admin/Index';

import CompanyList from '@/views/pages/admin/companies/List';
import CompanyDetail from '@/views/pages/admin/companies/Detail';
import CompanyPreview from '@/views/pages/admin/companies/detail/Preview';
import CompanyUsers from '@/views/pages/admin/companies/detail/Users';
import CompanyVehicles from '@/views/pages/admin/companies/detail/Vehicles';
import CompanyEmployees from '@/views/pages/admin/companies/detail/Employees';
import CompanyPartners from '@/views/pages/admin/companies/detail/Partners';
import CompanySubsidiaries from '@/views/pages/admin/companies/detail/Subsidiaries';
import CompanyAdditionalData from '@/views/pages/admin/companies/detail/AdditionalData';
import CompanyPreset from '@/views/pages/admin/companies/detail/ShipmentPreset';
import CompanyCreateEdit from '@/views/pages/admin/companies/CreateEdit';

import UserList from '@/views/pages/admin/users/List';
import UserDetail from '@/views/pages/admin/users/Detail';
import UserPreview from '@/views/pages/admin/users/detail/Preview';
import UserCreateEdit from '@/views/pages/admin/users/CreateEdit';
import UserAdditionalData from '@/views/pages/admin/users/detail/AdditionalData';
import UserAsignVehicle from '@/views/pages/admin/users/detail/AssignVehicle';

import VehicleList from '@/views/pages/admin/vehicles/List';
import VehicleDetail from '@/views/pages/admin/vehicles/Detail';
import VehiclePreview from '@/views/pages/admin/vehicles/detail/Preview';
import VehicleGPSDevices from '@/views/pages/admin/vehicles/detail/GPSDevices';
import VehicleAdditionalData from '@/views/pages/admin/vehicles/detail/AdditionalData';
import VehicleCreateEdit from '@/views/pages/admin/vehicles/CreateEdit';
import VehiclePrestartChecklist from '@/views/pages/admin/vehicles/detail/PrestartChecklistVehicle';
import VehicleUser from '@/views/pages/admin/vehicles/detail/User';

import EmployeeList from '@/views/pages/admin/employees/List';
import EmployeeDetail from '@/views/pages/admin/employees/Detail';
import EmployeePreview from '@/views/pages/admin/employees/detail/Preview';
import EmployeeUser from '@/views/pages/admin/employees/detail/User';
import EmployeeAdditionalData from '@/views/pages/admin/employees/detail/AdditionalData';
import EmployeeCreateEdit from '@/views/pages/admin/employees/CreateEdit';

import PrestartList from '@/views/pages/admin/prestart_checklist/List';
import PrestartCreateEdit from '@/views/pages/admin/prestart_checklist/CreateEdit';

import SetStatusShipment from '@/views/pages/admin/set_status_shipment/Index';


export default {
  path: 'admin',
  component: Empty,
  meta: {
    userTypes: ['SYSTEM_ADMIN', 'ADMIN'],
  },
  children: [
    {
      path: '',
      name: 'Admin Area',
      component: AdminIndex,
    },
    {
      path: 'companies',
      component: Empty,
      // redirect: 'companies/',
      children: [
        {
          path: '',
          name: 'Companies',
          component: CompanyList,
          meta: {
            accessKey: 'MAIN.COMPANY.READ',
          },
        },
        {
          path: 'create',
          name: 'Create Company',
          component: CompanyCreateEdit,
        },
        {
          path: ':companyId',
          component: CompanyDetail,
          children: [
            {
              path: '',
              name: 'Company Preview',
              component: CompanyPreview,
            },
            {
              path: 'users',
              name: 'Company Users',
              component: CompanyUsers,
            },
            {
              path: 'vehicles',
              name: 'Company Vehicles',
              component: CompanyVehicles,
            },
            {
              path: 'employees',
              name: 'Company Employees',
              component: CompanyEmployees,
            },
            {
              path: 'partners',
              name: 'Company Partners',
              component: CompanyPartners,
            },
            {
              path: 'subsidiaries',
              name: 'Company Subsidiaries',
              component: CompanySubsidiaries,
            },
            {
              path: 'additional',
              name: 'Company Additional Data',
              component: CompanyAdditionalData,
            },
            {
              path: 'shipment_preset',
              name: 'Company Shipment Preset',
              component: CompanyPreset,
            },
          ],
        },
        {
          path: ':companyId/edit',
          name: 'Edit Company',
          component: CompanyCreateEdit,
        },
      ],
    },
    {
      path: 'users',
      component: Empty,
      // redirect: 'users/',
      children: [
        {
          path: '',
          name: 'Users',
          component: UserList,
        },
        {
          path: 'create',
          component: UserCreateEdit,
          name: 'Create User',
        },
        {
          path: ':userId',
          component: UserDetail,
          children: [
            {
              path: '',
              name: 'User Preview',
              component: UserPreview,
            },
            {
              path: 'additional',
              name: 'User Additional Data',
              component: UserAdditionalData,
            },
            {
              path: 'assign_vehicle',
              name: 'User Assign Vehicle',
              component: UserAsignVehicle,
            },
          ],
        },
        {
          path: ':userId/edit',
          component: UserCreateEdit,
          name: 'Edit User',
        },
      ],
    },
    {
      path: 'vehicles',
      component: Empty,
      // redirect: 'vehicles/',
      children: [
        {
          path: '',
          name: 'Vehicles',
          component: VehicleList,
          meta: {
            accessKey: 'MAIN.VEHICLE.READ',
          },
        },
        {
          path: 'create',
          name: 'Create Vehicle',
          component: VehicleCreateEdit,
        },
        {
          path: ':vehicleId',
          component: VehicleDetail,
          children: [
            {
              path: '',
              name: 'Vehicle Preview',
              component: VehiclePreview,
            },
            {
              path: 'gps_devices',
              name: 'Vehicle GPS Devices',
              component: VehicleGPSDevices,
            },
            {
              path: 'additional',
              name: 'Vehicle Additional Data',
              component: VehicleAdditionalData,
            },
            {
              path: 'prestart_checklist_vehicle',
              name: 'Vehicle Prestart Checklist',
              component: VehiclePrestartChecklist,
            },
            {
              path: 'user',
              name: 'Vehicle User',
              component: VehicleUser,
            },
          ],
        },
        {
          path: ':vehicleId/edit',
          component: VehicleCreateEdit,
          name: 'Edit Vehicle',
        },
      ],
    },
    {
      path: 'employees',
      component: Empty,
      // redirect: 'employees/',
      children: [
        {
          path: '',
          name: 'Employees',
          component: EmployeeList,
          meta: {
            accessKey: 'MAIN.EMPLOYEE.READ',
          },
        },
        {
          path: 'create',
          name: 'Create Employee',
          component: EmployeeCreateEdit,
        },
        {
          path: ':employeeId',
          component: EmployeeDetail,
          children: [
            {
              path: '',
              name: 'Employee Preview',
              component: EmployeePreview,
            },
            {
              path: 'user',
              name: 'Employee User',
              component: EmployeeUser,
            },
            {
              path: 'additional',
              name: 'Employee Additional Data',
              component: EmployeeAdditionalData,
            },
          ],
        },
        {
          path: ':employeeId/edit',
          component: EmployeeCreateEdit,
          name: 'Edit Employee',
        },
      ],
    },
    {
      path: 'prestart_checklist',
      component: Empty,
      children: [
        {
          path: '',
          name: 'Prestart Checklist',
          component: PrestartList,
          meta: {
            accessKey: 'MAIN.PRESTART_CHECKLIST.READ',
          },
        },
        {
          path: 'create',
          name: 'Create Prestart',
          component: PrestartCreateEdit,
          meta: {
            accessKey: 'MAIN.PRESTART_CHECKLIST.CREATE',
          },
        },
        {
          path: ':prestartId/edit',
          component: PrestartCreateEdit,
          name: 'Edit Prestart',
          meta: {
            accessKey: 'MAIN.PRESTART_CHECKLIST.UPDATE',
          },
        },
      ],
    },
    {
      path: 'set_status_shipment',
      component: Empty,
      children: [
        {
          path: '',
          name: 'Set Status Checklist',
          component: SetStatusShipment,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/admin.js